import './Services.css';
import ServicesContent from './ServicesContent';
import SideMenu from '../SideMenu';
import SethL from '../../images/SethLI2P.jpg';
import DummyResume from '../../images/Portfolio2_DummyResume.pdf';
import VoicemailIcon from '../../images/Portfolio2VoicemailIcon.png';
import MailIcon from '../../images/Portfolio2MailIcon.png';
import ProfileIcon from '../../images/Portfolio2ProfileIcon.png';
import LocationIcon from '../../images/Portfolio2LocationIcon.png';

function Services() {
  return (
    <div className = 'services'>
      <SideMenu />
      <div className = 'services-content'>
        <ServicesContent />
      </div>   
    </div>
  );
}

export default Services;